import template from './delegatedCardAvatar.html';
import './delegatedCardAvatar.scss';

let delegatedCardAvatarComponent = {
  restrict: 'E',
  bindings: {
    employeeProfile: '<',
  },
  template,
};

export default delegatedCardAvatarComponent;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardAvatar/delegatedCardAvatar.component.js